import FilterGroup from './FilterGroup';

export default FilterGroup;



// WEBPACK FOOTER //
// ./src/components/FilterGroup/index.jsx